<div class="row">
    <div class="col-md-12 vh-100">
            <ag-grid-angular
            class="ag-theme-alpine"
            [gridOptions]="gridOptions"
            (gridReady)="gridSetting($event)"
            (firstDataRendered)="restoreGridState($event)"
            (paginationChanged)="saveGridState($event)"
            (sortChanged)="saveGridState($event)"
            [columnDefs]="columnDefs"
            [rowData]="list"
            [domLayout]="'autoHeight'"
            [pagination]= "true"
            [paginationPageSize]="10"
            [paginationPageSizeSelector]="[10,20,30]"
            [enableCellTextSelection]="true"            >
            </ag-grid-angular>
            <ag-grid-angular
            class="ag-theme-alpine mt-4"
            [gridOptions]="gridOptions"
            (gridReady)="gridSetting($event)"
            [columnDefs]="activeColumnDefs"
            [rowData]="activeTrucks"
            [domLayout]="'autoHeight'"
            [pagination]= "true"
            [paginationPageSize]="5"
            [paginationPageSizeSelector]="[5,10,15]"
            [enableCellTextSelection]="true">
            </ag-grid-angular>
    </div>
</div>
